module.exports = __webpack_public_path__ + "fonts/VetoSans-Light_1.26423d08.eot";